import angular from 'angular';
import './exportbuilder.publish.constants';
import './exportbuilder.publish.components';
import './exportbuilder.publish.models';

angular.module('exportbuilder.publish', [
    'exportbuilder.publish.constants',
    'exportbuilder.publish.components',
    'exportbuilder.publish.models'
]);